import {BadgeTypeVo} from '../../common/shared/api/gateway/enums/BadgeTypeVo.enum';
import {BadgeTypeVo as NicolasBadgeTypeVo} from '../../common/shared/api/nicolas/vo/enums/BadgeTypeVo.enum';
import {BadgeType} from '../generated/types';

export function createBadgeType(
  param:
    | {
        karinaBadgeTypeVo: {badge: BadgeTypeVo; isRoundBadge?: boolean};
      }
    | {
        nicolasBadgeTypeVo: {
          badge: NicolasBadgeTypeVo;
        };
      }
): BadgeType | undefined {
  if ('karinaBadgeTypeVo' in param) {
    return withKarinaBadgeTypeVo(param.karinaBadgeTypeVo);
  } else {
    return withNicolasBadgeTypeVo(param.nicolasBadgeTypeVo);
  }
}

/**
 * TODO: BadgeTypeVo를 디자인에서 정한 BadgeType으로 바꾸는 함수입니다.
 * 카리나의 BadgeTypeVo가 디자인 가이드의 모든 BadgeType을 핸들링하지 못하므로, BadgeTypeVo와 1:1 대응되는 뱃지만 핸들링합니다.
 * 현재는 BadgeTypeVo에 대응하는 뱃지가 없으면 undefined를 리턴하지만, 추후 에러 처리 로직이 붙어야 합니다.
 */
function withKarinaBadgeTypeVo({
  badge,
}: {
  badge: BadgeTypeVo;
}): BadgeType | undefined {
  switch (badge) {
    case BadgeTypeVo.Up: {
      return BadgeType.BadgeUpStatic;
    }
    case BadgeTypeVo.New: {
      return BadgeType.BadgeNewStatic;
    }
    case BadgeTypeVo.Free: {
      return BadgeType.BadgeRealFreeStatic;
    }
    case BadgeTypeVo.Event: {
      return BadgeType.BadgeEventStatic;
    }
    case BadgeTypeVo.Waitfree: {
      return BadgeType.BadgeWaitFreeStatic;
    }
  }
  return;
}

function withNicolasBadgeTypeVo({
  badge,
}: {
  badge: NicolasBadgeTypeVo;
}): BadgeType | undefined {
  switch (badge) {
    case NicolasBadgeTypeVo.Up: {
      return BadgeType.BadgeUpStatic;
    }
    case NicolasBadgeTypeVo.New: {
      return BadgeType.BadgeNewStatic;
    }
    case NicolasBadgeTypeVo.Free: {
      return BadgeType.BadgeRealFreeStatic;
    }
    case NicolasBadgeTypeVo.Event: {
      return BadgeType.BadgeEventStatic;
    }
  }
  return;
}
